import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { approvalFormTableStyles } from '@/components/Approval/@components/ApprovalFormTable';

/**
 * 저장 HTML 은 레거시 마크업(table-bordered 등 Bootstrap 클래스) 그대로라 클래스가 아닌 태그로 스타일링.
 * 레거시 문서와 V2 문서가 같은 모양으로 보이게 함
 */
export const DiscountVoucherTables = styled(Box)(({ theme }) => ({
  overflowX: 'auto',
  WebkitOverflowScrolling: 'touch',
  '& > div + div': { marginTop: 8 },
  '& table': approvalFormTableStyles(theme),
  // 레거시 저장 표는 칸 8개에 col 9개 — 고정 폭이면 빈 열이 폭을 차지함
  '& table:has(> colgroup > col:nth-of-type(9))': { tableLayout: 'auto' },
  '& .text-center': { textAlign: 'center' },
  '& .text-left': { textAlign: 'left' },
}));

export const DiscountVoucherToggleRow = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-end',
  margin: '8px 0',
});
